import Vue from 'vue'
import store from '../store';
import axios from 'axios';
import App from './app';


new Vue({
    store,
    mounted() {
        const self = this;
        axios
            .get(process.env.VUE_APP_DATAHUB_URL + "menu")
            .then((response) => {
                self.$store.dispatch("addMenu", response.data)
            })
    },
    render: h => h(App)
}).$mount('#stage-container');
